import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Header from "../../constants/Header";
import { getDirectAnswer, getSearchResults } from "./network_requests";
import axios from "axios";
import SearchTabs from "./components/SearchTabs";
import "./results.css";
import Sector from "./components/Sectors";
import { setFilters } from "../../redux/filters";
import { setStates } from "../../redux/states";
import Filters from "./components/Filters";
import { Box, CircularProgress, Grid, Typography } from "@material-ui/core";
import CompanyCard from "./components/CompanyCard";
import Searchbar from "../../constants/Searchbar";
import BondCard from "./components/BondCard";
import CompanyCardMobile from "./components/CompanyCardMobile";
import CustomPagination from "../../constants/CustomPagination";
import ETFCard from "./components/ETFCard";
import ETFCardMobile from "./components/ETFCardMobile";
import { useHistory, useParams } from "react-router-dom";
import Alpha from "../../constants/Alpha";
import DirectAnswer from "./components/DirectAnswer";
import BondCardMobile from "./components/BondCardMobile";
import { withNamespaces } from "react-i18next";
import IndexGraph from "./components/IndexGraph";
import ListCard from "./components/ListCard";
import ListCardMobile from "./components/ListCardMobile";

function SearchResults({ t }) {
  const states = useSelector((state) => state.states.value);
  const filters = useSelector((state) => state.filters.value);
  const history = useHistory();
  let { tab, query } = useParams();

  const dispatch = useDispatch();
  const [companies, setCompanies] = useState(
    states?.companies ? states?.companies[0] : []
  );
  const [Sectors, setSectors] = useState(
    states?.Sectors ? states?.Sectors : []
  );
  const [ISINList, setISINList] = useState(states?.ISIN ? states?.ISIN : []);
  const [cancelTokenState, setCancelTokenState] = useState(null);
  const [page, setPage] = useState(states?.page ? states?.page : 1);
  const [Session_Object, setSession_Object] = useState(
    states?.Session_Object ? states.Session_Object : null
  );

  const [bondCompanies, setBondCompanies] = useState(
    states?.bondCompanies ? states?.bondCompanies : null
  );
  const [tabValue, setTabValue] = useState(parseInt(tab));
  const [numberOfBond, setNumberOfBond] = useState(
    states?.numberOfBond ? states?.numberOfBond : 0
  );
  const [numberOfStock, setNumberOfStock] = useState(
    states?.numberOfStock ? states?.numberOfStock : 0
  );
  const [numberOfETF, setNumberOfETF] = useState(
    states?.numberOfETF ? states?.numberOfETF : 0
  );
  const [load, setLoad] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [isServerDown, setIsServerDown] = useState(false);
  const [countries, setCountries] = useState(
    states?.countries ? states?.countries : []
  );
  const [continents, setContinents] = useState(
    states?.continents ? states?.continents : []
  );
  const [clickable, setClickable] = useState(true);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const isMount = useState(null);
  const isMounted1 = useRef(null);
  const isMounted2 = useRef(null);
  const isMounted3 = useRef(null);
  const [companyDetail, setCompanyDetail] = useState(null);
  const [directAnswer, setDirectAnswer] = useState(null);
  const [isFixedHeader, setIsFixedHeader] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const y = window.pageYOffset;
      setIsFixedHeader(y > 280 ? true : false);
    });
  });

  useEffect(() => {
    if (companyDetail) {
      dispatch(
        setStates({
          ...states,
          companies: [[...companies]],
          filters: filters,
          tabValue: tabValue,
          countries: countries,
          continents: continents,
          Sectors: Sectors,
          Session_Object: Session_Object,
          ISIN: ISINList,
          page: page,
          numberOfStock: numberOfStock,
          numberOfBond: numberOfBond,
          numberOfETF: numberOfETF,
          bonds: tabValue === 0 ? true : false,
          bondCompanies: bondCompanies,
        })
      );
      history.push(`/search-details/${query}/${companyDetail}/${tabValue}`);
    }
  }, [companyDetail]);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${query} - Stoqqy Search`;
  }, [query]);

  // useEffect(() => {
  //   setTabValue(states.tabValue);
  // }, [states.tabValue]);

  useEffect(() => {
    if (query && (isMount?.current || states?.companies?.length === 0)) {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      setDirectAnswer({});
      cancelTokenState?.cancel();
      setCancelTokenState(source);
      setTabValue(parseInt(tab));
      isMount.current = true;
      (async () => {
        setCompanies([]);
        isMounted1.current = false;
        setPage(states.tabValue ? states.tabValue : 1);
        setContinents([]);
        setCountries([]);
        setLoad(true);
        setClickable(false);
        setSectors([]);
        const data = await getSearchResults(query, filters, null, 1, 1, source);
        const data1 = await getSearchResults(
          query,
          filters,
          null,
          1,
          2,
          source
        );

        if (
          data !== "canceled" &&
          data1 !== "canceled" &&
          data !== "error" &&
          data1 != "error"
        ) {
          setIsServerDown(false);
          setCompanies(data?.companies ? data?.companies : []);
          setSectors(data?.Sector ? data?.Sector : []);
          setBondCompanies(data?.Number_of_Bonds_companies);
          setNumberOfBond(data?.Number_of_Bonds);
          setNumberOfStock(data?.Number_of_Stock);
          setSession_Object(data?.Session_Object);
          setISINList(data?.ISIN);
          setNumberOfETF(data1?.Number_of_Etfs);
          setNoResults(data?.companies?.length > 0 ? false : true);
          setContinents(data?.Continent);
          setCountries(data?.Country);
          setLoad(false);
        } else if (data === "error" || data1 == "error") {
          setLoad(false);
          setIsServerDown(true);
        }

        if (
          data?.companies?.length > 0
            ? data?.companies[0].Price
              ? false
              : true
            : true
        ) {
          const data2 = await getSearchResults(
            query,
            filters,
            data?.Session_Object,
            1,
            tabValue,
            source
          );
          setNoResults(data2?.companies?.length > 0 ? false : true);
          setCompanies(data2?.companies);
        }
        const directAns = await getDirectAnswer(query);
        setDirectAnswer(directAns);

        setClickable(true);
      })();

      return () => {
        source.cancel();
      };
    }
  }, [states?.name, states?.ISIN]);

  useEffect(() => {
    if (isMounted1.current) {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      cancelTokenState?.cancel();
      setCancelTokenState(source);
      (async () => {
        setIsServerDown(false);
        setCompanies([]);
        setLoad(true);
        const data = await getSearchResults(
          query,
          filters,
          Session_Object,
          page,
          tabValue,
          source
        );

        if (data !== "canceled" && data !== "error") {
          setCompanies(data?.companies);
          setNoResults(data?.companies?.length > 0 ? false : true);
          setISINList(data?.ISIN);
          setNumberOfETF(data?.Number_of_Etfs);

          window.scrollTo(0, 0);
          setLoad(false);
        } else if (data === "error") {
          setLoad(false);
          setIsServerDown(true);
        }
      })();
      return () => {
        source.cancel();
      };
    } else {
      isMounted1.current = true;
    }
  }, [page]);

  useEffect(() => {
    if (isMounted2.current) {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      cancelTokenState?.cancel();
      setCancelTokenState(source);
      (async () => {
        setCompanies([]);
        setPage(1);
        setLoad(true);
        const data = await getSearchResults(
          query,
          tabValue === 0 ? { ...filters, Bonds: true } : { ...filters },
          Session_Object,
          page,
          tabValue,
          source
        );
        if (data !== "canceled" && data !== "error") {
          setIsServerDown(false);
          setCompanies(data?.companies);
          setNoResults(data?.companies?.length > 0 ? false : true);
          setNumberOfBond(
            data?.Number_of_Bonds || data?.Number_of_Bonds === 0
              ? data?.Number_of_Bonds
              : numberOfBond
          );
          setNumberOfStock(
            data?.Number_of_Stock || data?.Number_of_Stock === 0
              ? data?.Number_of_Stock
              : numberOfStock
          );
          setISINList(data?.ISIN);
          setSectors(
            Sectors?.length === 0 ? (data?.Sector ? data?.Sector : []) : Sectors
          );

          window.scrollTo(0, 0);
          setLoad(false);
        } else if (data === "error") {
          setLoad(false);
          setIsServerDown(true);
        }
      })();
      return () => {
        source.cancel();
      };
    } else {
      isMounted2.current = true;
    }
  }, [filters.Sector, filters.order_by, filters.Country, filters.Continent]);

  useEffect(() => {
    if (isMounted3.current) {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();

      cancelTokenState?.cancel();
      setCancelTokenState(source);
      (async () => {
        setCompanies([]);
        setPage(1);
        setContinents([]);
        setCountries([]);
        setLoad(true);
        setDirectAnswer({});
        setClickable(false);

        const data = await getSearchResults(
          query,
          tabValue === 0 ? { ...filters, Bonds: true } : { ...filters },
          null,
          1,
          tabValue,
          source
        );
        const data1 = await getSearchResults(
          query,
          filters,
          null,
          1,
          tabValue !== 2 ? 2 : 1,
          source
        );
        // console.log(data.response, data1.response);
        if (
          data !== "canceled" &&
          data1 !== "canceled" &&
          data !== "error" &&
          data1 != "error"
        ) {
          setIsServerDown(false);
          setCompanies(data?.companies ? data?.companies : []);
          setSectors(data?.Sector ? data?.Sector : []);
          setBondCompanies(
            tabValue === 2
              ? data1?.Number_of_Bonds_companies
              : data?.Number_of_Bonds_companies
          );
          setNumberOfBond(
            tabValue === 2 ? data1?.Number_of_Bonds : data?.Number_of_Bonds
          );
          setNumberOfStock(
            tabValue === 2 ? data1?.Number_of_Stock : data?.Number_of_Stock
          );
          setSession_Object(data?.Session_Object);
          setISINList(data?.ISIN);
          setNumberOfETF(
            tabValue !== 2 ? data1?.Number_of_Etfs : data?.Number_of_Etfs
          );
          setNoResults(data?.companies?.length > 0 ? false : true);

          setContinents(data?.Continent);
          setCountries(data?.Country);

          setLoad(false);
        } else if (data === "error" || data1 == "error") {
          setLoad(false);
          setIsServerDown(true);
        }
        if (
          tabValue !== 2 && data?.companies?.length > 0
            ? data?.companies[0].Price
              ? false
              : true
            : true
        ) {
          const data2 = await getSearchResults(
            query,
            tabValue === 0 ? { ...filters, Bonds: true } : { ...filters },
            data?.Session_Object,
            1,
            tabValue,
            source
          );

          setCompanies(data2?.companies);
          setNoResults(data2?.companies?.length > 0 ? false : true);
          const directAns = await getDirectAnswer(query);
          setDirectAnswer(directAns);
        }
        setClickable(true);
      })();
      return () => {
        source.cancel();
      };
    } else {
      isMounted3.current = true;
    }
    dispatch(
      setStates({
        ...states,
        tabValue: tabValue,
      })
    );
  }, [tabValue]);

  return (
    <div style={{ minHeight: "100vh", maxWidth: "100%", overflowX: "hidden" }}>
      {isFixedHeader ? (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              zIndex: 500,
              left: 0,
              width: "100%",
            }}
          >
            <Header fixed={true} placeHolder={t("search_placeholder")} t={t} />
          </div>
        </>
      ) : null}
      <div
        style={{
          position: isDesktopOrLaptop ? "absolute" : "",
          width: "100%",
          left: 0,
          top: 0,
        }}
      >
        <Header placeHolder={t("search_placeholder")} t={t} />
        <div
          style={{
            padding: isDesktopOrLaptop ? 0 : "14px 15px 0px 11px",
            backgroundColor: "#f8f8f8",
          }}
        >
          {!isDesktopOrLaptop ? <Searchbar unfocused={true} /> : null}
          <SearchTabs
            tabValue={tabValue}
            setTabValue={setTabValue}
            numberOfBond={numberOfBond}
            numberOfETF={numberOfETF}
            numberOfStock={numberOfStock}
            t={t}
          />
        </div>
      </div>
      {isDesktopOrLaptop ? <div style={{ height: "153px" }} /> : null}
      {tabValue != 2 ? <Sector Sectors={Sectors} t={t} /> : null}
      <Filters
        countries={countries}
        continents={continents}
        tabValue={tabValue}
        t={t}
      />
      <DirectAnswer answer={directAnswer} />

      {companies?.length > 0 ? (
        <>
          <div>
            <IndexGraph query={query} filters={filters} t={t} />
          </div>
        </>
      ) : null}

      <Box
        flexWrap="wrap"
        style={{
          paddingLeft: isDesktopOrLaptop ? "98px" : null,
          paddingRight: isDesktopOrLaptop ? "98px" : null,
        }}
      >
        {companies?.length > 0 && isDesktopOrLaptop ? (
          <Grid
            style={{
              paddingLeft: "243px",
              display: "flex",
              width: "757px",
              margin: "10px 0 0 0",
            }}
          >
            <Grid item xs={2}>
              <Typography
                style={{
                  color: "#808080",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  cursor: "pointer",
                  textAlign: "center",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                }}
              >
                {tabValue === 2 ? t("symbol") : t("company")}
              </Typography>
            </Grid>
            <Grid item xs={4} />

            <Grid item xs={3}>
              <Typography
                style={{
                  color: "#808080",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  height: "27px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {tabValue === 2 ? t("issuer") : t("sector")}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                style={{
                  color: "#808080",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  height: "27px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  textAlign: "end",
                }}
              >
                {tabValue === 2 ? t("assets") : t("market_cap")}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography
                style={{
                  color: "#808080",
                  fontSize: "14px",
                  fontFamily: "Overpass",
                  height: "27px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {t("country")}
              </Typography>
            </Grid>
          </Grid>
        ) : null}

        {companies?.map((Company, index) => {
          return isDesktopOrLaptop ? (
            <div style={{ display: "flex", width: "100%" }}>
              {tabValue === 2 ? (
                <ETFCard
                  Company={Company}
                  setCompanyDetail={setCompanyDetail}
                  clickable={clickable}
                  t={t}
                  tabValue={tabValue}
                />
              ) : tabValue === 0 ? (
                <BondCard
                  Company={Company}
                  tabValue={tabValue}
                  setCompanyDetail={setCompanyDetail}
                  clickable={clickable}
                  t={t}
                />
              ) : (
                <ListCard
                  Company={Company}
                  tabValue={tabValue}
                  setCompanyDetail={setCompanyDetail}
                  clickable={clickable}
                  t={t}
                />
                // <CompanyCard
                //   Company={Company}
                //   tabValue={tabValue}
                //   setCompanyDetail={setCompanyDetail}
                //   clickable={clickable}
                //   t={t}
                // />
              )}
              {/* {index === 0 ? (
                <div
                  style={{
                    margin: "0px 0 0 69px",
                  }}
                >
                  <Alpha height="45px" width="174px" t={t} />
                </div>
              ) : null} */}
            </div>
          ) : tabValue === 2 ? (
            <ETFCardMobile
              Company={Company}
              setCompanyDetail={setCompanyDetail}
              clickable={clickable}
              t={t}
            />
          ) : tabValue === 0 ? (
            <BondCardMobile
              Company={Company}
              tabValue={tabValue}
              setCompanyDetail={setCompanyDetail}
              clickable={clickable}
              t={t}
            />
          ) : (
            <ListCardMobile
              Company={Company}
              tabValue={tabValue}
              setCompanyDetail={setCompanyDetail}
              clickable={clickable}
              t={t}
            />
            // <CompanyCardMobile
            //   Company={Company}
            //   tabValue={tabValue}
            //   setCompanyDetail={setCompanyDetail}
            //   clickable={clickable}
            //   t={t}
            // />
          );
        })}
      </Box>
      {!load &&
      !isServerDown &&
      (tabValue === 0
        ? bondCompanies > 20
        : tabValue === 1
        ? numberOfStock > 20
        : numberOfETF > 20) ? (
        <CustomPagination
          page={page}
          margin={isDesktopOrLaptop ? 0 : "3px"}
          totalPages={Math.ceil(
            (tabValue === 0
              ? bondCompanies
              : tabValue === 1
              ? numberOfStock
              : numberOfETF) / 20
          )}
          setPage={setPage}
        />
      ) : null}

      {load ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            paddingTop: "20vh",
          }}
        >
          <CircularProgress style={{ color: "#808080" }} />
        </div>
      ) : isServerDown ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={isDesktopOrLaptop ? 6 : 10}>
            <p
              style={{
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "38px" : "26px",
                fontWeight: "bold",
                color: "#16063b",
                textAlign: "center",
                marginTop: "45px",
              }}
            >
              {t("server_down")} 😔
            </p>
          </Grid>
        </div>
      ) : noResults ? (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Grid item xs={isDesktopOrLaptop ? 6 : 10}>
            <p
              style={{
                fontFamily: "Overpass",
                fontSize: isDesktopOrLaptop ? "38px" : "26px",
                fontWeight: "bold",
                color: "#16063b",
                textAlign: "center",
                marginTop: "45px",
              }}
            >
              {t("no_results")} 😔
            </p>
          </Grid>
        </div>
      ) : null}
    </div>
  );
}

export default withNamespaces()(SearchResults);
